/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_WashersInputs */

const he_home_category_washers = /** @type {(inputs: Home_Category_WashersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מכונות כביסה`)
};

const en_home_category_washers = /** @type {(inputs: Home_Category_WashersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washing Machines`)
};

/**
* | output |
* | --- |
* | "Washing Machines" |
*
* @param {Home_Category_WashersInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_washers = /** @type {((inputs?: Home_Category_WashersInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_WashersInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_washers(inputs)
	return en_home_category_washers(inputs)
});